<h2 mat-dialog-title>{{ isNew ? 'Tambah' : 'Ubah' }} Pengajuan Cuti</h2>
<div mat-dialog-content>
    <div class="row">
        <form class="form-container" name="form" #f="ngForm" novalidate>
            <mat-form-field *ngIf="tokenStorageService.isSuperadmin()" appearance="outline">
                <mat-label>Nomor</mat-label>
                <input matInput [formControl]="nomor" />
                <mat-error *ngIf="nomor.invalid">{{
                    FormUtils.getErrorMessage(nomor)
                    }}</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Jenis Cuti</mat-label>
                <mat-select [formControl]="jenis" ngDefaultControl required="true">
                    <mat-option *ngFor="let item of jenisCutis" [value]="item.id">
                        {{ item.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline">
                <mat-label>Alasan</mat-label>
                <input matInput [formControl]="alasan" required />
                <mat-error *ngIf="alasan.invalid">{{
                    FormUtils.getErrorMessage(alasan)
                    }}</mat-error>
            </mat-form-field>
            <div class="row">
                <mat-label>Tanggal Cuti</mat-label>
                <div class="row">
                    <div *ngFor="let d of dates">
                        {{ displayDate(d) }}
                        <button mat-icon-button (click)="removeDate(d)" matTooltip="Hapus" matTooltipPosition="above">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>
                <div fxLayout="row wrap">
                    <div fxFlex.gt-lg="70" fxFlex.gt-md="70" fxFlex.gt-xs="100" fxFlex="100">
                        <mat-form-field appearance="outline">
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate [formControl]="fromDate" placeholder="Mulai Tanggal">
                                <input matEndDate [formControl]="toDate" placeholder="Sampai Tanggal">
                            </mat-date-range-input>
                            <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                    </div>
                    <div fxFlex.gt-lg="30" fxFlex.gt-md="30" fxFlex.gt-xs="100" fxFlex="100"
                        style="padding-left: 20px;">
                        <button mat-mini-fab color="primary" (click)="addDate()">
                            <mat-icon>add</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <mat-form-field appearance="outline">
                <mat-label>Lamanya Cuti</mat-label>
                <input matInput [formControl]="jumlah" inputType="number" readonly="true" required />
                <mat-error *ngIf="jumlah.invalid">{{
                    FormUtils.getErrorMessage(jumlah)
                    }}</mat-error>
            </mat-form-field>
            <mat-form-field style="margin-top: 16px;" appearance="outline">
                <mat-label>Alamat Selama Menjalankan Cuti</mat-label>
                <input matInput [formControl]="address" required />
                <mat-error *ngIf="address.invalid">{{
                    FormUtils.getErrorMessage(address)
                    }}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Telepon</mat-label>
                <input matInput [formControl]="telp" required />
                <mat-error *ngIf="address.invalid">{{
                    FormUtils.getErrorMessage(address)
                    }}</mat-error>
            </mat-form-field>

            Lampiran
            <input [formControl]="uploadFileForm" type="file" class="btn-primary" multiple="multiple" />
        </form>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close *ngIf="!isLoading">Batal</button>
    <button mat-raised-button cdkFocusInitial color="primary" *ngIf="!isLoading" (click)="onSave()">
        Simpan
    </button>
    <!-- <button mat-raised-button cdkFocusInitial color="primary" *ngIf="!isLoading" (click)="onSaveSubmit()">
        Ajukan
    </button> -->
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
</div>